import { render, staticRenderFns } from "./physical.vue?vue&type=template&id=9d06f294&scoped=true&"
import script from "./physical.vue?vue&type=script&lang=js&"
export * from "./physical.vue?vue&type=script&lang=js&"
import style0 from "./physical.vue?vue&type=style&index=0&id=9d06f294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d06f294",
  null
  
)

export default component.exports